// Values are either max characters in database or by type format
export default {
    CREDIT_CARD_MIN: 15,
    CREDIT_CARD_MAX: 16,
    SECURITY_CODE_MIN: 4,
    SECURITY_CODE_MAX: 5,
    PASSWORD_MIN: 8,
    PASSWORD_MAX: 64,
    FIRST_NAME_MAX: 128,
    LAST_NAME_MAX: 128,
    FULL_NAME_MAX: 256,
    EMAIL_MAX: 256,
    PHONE_NUMBER_MAX: 14,
    ADDRESS_MAX: 128,
    CITY_MAX: 64,
    COUNTRY_MAX: 45,
    POSTAL_CODE_MAX: 64,
    YEAR_MAX: 4,
    DAY_MAX: 2,
    MONTH_MAX: 2,
    MAKE_MAX: 64,
    MODEL_MAX: 64,
    TRIM_MAX: 64,
    COLOR_MAX: 45,
    ODOMETER_MAX: 7,
    VIN_MIN: 17,
    VIN_MAX: 17,
    DEFAULT_NUMBER_MAX: 11,
};
